import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Centralized hook for checking super admin status with aggressive caching
 * Caches result for entire session to eliminate redundant RPC calls
 */
export const useSuperAdminCheck = () => {
  return useQuery({
    queryKey: ['super-admin-status'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { data } = await supabase.rpc('is_super_admin', {
        _user_id: user.id
      });

      return !!data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: true,
    refetchOnMount: false,
  });
};
